import { RouteRecordRaw } from "vue-router";
import { UserRoleEnum } from "@/app/core/enums/UserRoleEnum";

export const routePrivateOffers: Array<RouteRecordRaw> = [
  {
    path: "offers/:uuid?",
    name: "Offers",
    meta: {
      requireAuth: true,
      roles: [UserRoleEnum.Shipper, UserRoleEnum.Carrier, UserRoleEnum.Master],
    },
    redirect: (to) => {
      return { name: "OffersList", params: { uuid: to.params.uuid } };
    },
    component: () => import("@/app/private/pages/offers/Offers.vue"),
    children: [
      {
        path: "",
        name: "OffersList",
        component: () => import("@/app/private/pages/offers/OffersList.vue"),
      },
    ],
  },
];
